import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { NotificationService } from "../common/component/notification/notification.service";
import { FeedstockService } from "./feedstock.service";

@Component({
    selector: 'feedstock',
    templateUrl: './feedstock.component.html',
    styleUrls: ['./feedstock.component.scss']
})

export class FeedstockComponent implements OnInit {

    feedstock: any = { feedstockId: 0, feedstockName: '', note: '' };
    feedstocks: any[];
    isLoadPanelVisible: boolean = false;

    constructor(private notificationService: NotificationService, private route: ActivatedRoute, private feedstockService: FeedstockService) {

    }

    ngOnInit(): void {

        this.getFeedstock();
        this.route.params.subscribe(params => {
            if (params['id'] != null) {
                this.feedstock.feedstockId = Number(params['id']);

            }
        });
    }

    onFeedstockChange(event) {
        if (event.value) {
            this.feedstock.note = this.feedstocks.find(x => x.feedstockId == event.value).note;
        } else {
            this.feedstock.note = '';
        }
    }

    getFeedstock() {
        this.isLoadPanelVisible = true;
        this.feedstockService.getFeedstock().subscribe({
            next: feedstocks => {
                this.feedstocks = feedstocks
                if (this.feedstock.feedstockId) {
                    this.feedstock.note = this.feedstocks.find(x => x.feedstockId == this.feedstock.feedstockId).note;
                }

                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Feedstocks", error);
            }
        });
    }

    handleSubmit(e) {
        this.isLoadPanelVisible = true;

        if (this.feedstock.feedstockId) {
            this.feedstockService.updateFeedstock(this.feedstock).subscribe({
                next: feedstocks => {
                    this.feedstocks = feedstocks
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("success", "Updated Successfully", null);
                    window.self.close();
                }, error: (error: any) => {
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("error", "Error while Updating Feedstock", error);
                }
            });
        } else {
            this.feedstock.feedstockId = 0;
            this.feedstockService.addFeedstock(this.feedstock).subscribe({
                next: feedstocks => {
                    this.feedstocks = feedstocks
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("success", "Added Successfully", null);
                    window.self.close();
                }, error: (error: any) => {
                    this.isLoadPanelVisible = false;
                    this.notificationService.alert("error", "Error while adding Feedstock", error);
                }
            });
        }
    }
}